export default __webpack_public_path__ + "static/media/discord-block.32eb7c78.png";